/**
 * useUploadVideo Hook
 * Custom hook for uploading a profile video
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import apiClient from "@/lib/api-client"

async function uploadVideo(userId: string, file: File) {
  const formData = new FormData()
  formData.append("file", file)

  const { data } = await apiClient.post(`api/profiles/${userId}/videos`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })

  return data.data.video
}

export function useUploadVideo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userId, file }: { userId: string; file: File }) => uploadVideo(userId, file),
    onSuccess: async (_newVideo, variables) => {
      // Invalidate video query to trigger refetch
      queryClient.invalidateQueries({ queryKey: ["video", variables.userId] })
    },
  })
}
